var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","x-small":"","color":"black"},on:{"click":_vm.emitClick}},[_c('v-icon',[_vm._v("mdi-pencil")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }